import { INewsAlertEntry } from '../contentful/types/INewsAlertEntry';

export default function getMostRecentAlert(alerts?: INewsAlertEntry[]) {
	if (!alerts || alerts.length === 0) return undefined;
	const mostRecentAlert = alerts.reduce((mostRecent, currentItem) => {
		if (
			!mostRecent ||
			new Date(currentItem.updatedAt) > new Date(mostRecent.updatedAt)
		) {
			return currentItem;
		}
		return mostRecent;
	}, alerts[0]);
	return mostRecentAlert;
}
